import { baseSections } from './sections-base';
import { riverAbbotSections } from './sections-river-abbot';
import { major01to05Sections } from './sections-major-01-05';
import { major06to10Sections } from './sections-major-06-10';
import { majorGuideSections } from './sections-major-guides';
import { miniSections } from './sections-minis';
import { mistsSections } from './sections-mists';
import { interactionSections } from './sections-interactions';
import { RuleSection } from '../types';

export const allRuleSectionsRaw: RuleSection[] = [
  ...baseSections,
  ...riverAbbotSections,
  ...major01to05Sections,
  ...major06to10Sections,
  ...majorGuideSections,
  ...miniSections,
  ...mistsSections,
  ...interactionSections,
];
